import React from 'react'
import './styles.css'

const PageWrapper: React.FC<{}> = ({children}) => {
  return <main>{children}</main>
}

export default PageWrapper